import React from "react";
import { withNavBars } from "../../HOCs";
import CreateAccount from '../addAccount/createAccount'

const CustomerAccountCreateParent = () =>{
    return <CreateAccount reltype="Customer"/>
}
const props = {
    boxShadow: false
}
export default withNavBars(CustomerAccountCreateParent, props);
